module.exports = __webpack_public_path__ + "static/media/obestinado_p.c49ff757.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/obestinado_p.png
// module id = 1148
// module chunks = 0